import { useState } from 'react';
import { TestTube } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TestConnectionSheet } from './TestConnectionSheet';
import { ChatProvider } from '@/types/channels';

interface TestConnectionButtonProps {
  channelId: string;
  channelName: string;
  provider: string;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}

/**
 * TestConnectionButton
 *
 * Opens a Sheet to test channel connection with optional phone number
 */
export function TestConnectionButton({
  channelId,
  channelName,
  provider = ChatProvider.WHATICKET,
  variant = 'outline',
  size = 'sm',
  className,
}: TestConnectionButtonProps) {
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setIsSheetOpen(true)}
        className={className}
      >
        <TestTube className="w-4 h-4 mr-1" />
        Testar
      </Button>

      <TestConnectionSheet
        channelId={channelId}
        channelName={channelName}
        provider={provider}
        isOpen={isSheetOpen}
        onClose={() => setIsSheetOpen(false)}
      />
    </>
  );
}
